import { PatientPrescriptionsType, PaymentStatus } from 'enums/prescriptions';
import { PatientPrescription } from 'store/prescriptions/prescriptions.types';

export const initialState: PatientPrescription = {
  brandName: null,
  createdAt: '',
  deletedAt: '',
  fulfillmentState: '',
  id: '',
  isDocMed: false,
  isDraft: false,
  lmdPrescriptionId: null,
  medications: [],
  name: '',
  ndc: null,
  orderStatus: '',
  paymentStatus: PaymentStatus.Failed,
  qty: 0,
  qtyUnits: 'ml',
  renewal: 0,
  renewalTaskId: '',
  renews: '',
  requestTaskId: null,
  sig: '',
  signedAt: '',
  titrations: [],
  type: PatientPrescriptionsType.Prescription,
  user: {
    _id: '',
    address: '',
    city: '',
    email: '',
    patient: {
      activePlan: {
        planName: ''
      }
    },
    phone: {
      countryCode: '',
      countryPrefix: '',
      internationalFormat: '',
      phoneNumber: ''
    },
    state: '',
    zipCode: ''
  }
};
